<template>
    <div class="order-person-company">
        <div class="order-person-company__row row">
            <div class="col-12">
                <validation-provider rules="" #default="{ errors }">
                    <text-input-suggest
                        label="Название компании"
                        name="NEW_COMPANY[NAME]"
                        v-model="companyName"
                        :class="{ 'has-error': errors.length }"
                        placeholder="Название компании"
                        item-value-key="VALUE"
                        :items="suggestPersonCompanyName"
                        :status="errors[0]"
                        @input="getSuggestPersonCompanyName"
                        @select="completePersonCompany"
                        :readonly="isDisabled"
                        :disabled="isDisabled"
                    ></text-input-suggest>
                </validation-provider>
            </div>
        </div>

        <div class="order-person-company__row row">
            <div class="col-12">
                <validation-provider rules="" #default="{ errors }">
                    <text-input-suggest
                        label="Инн компании"
                        name="NEW_COMPANY[INN]"
                        v-model="companyInn"
                        :class="{ 'has-error': errors.length }"
                        placeholder="ИНН компании"
                        item-value-key="VALUE"
                        :items="suggestPersonCompanyInn"
                        :status="errors[0]"
                        @input="getSuggestPersonCompanyInn"
                        @select="completePersonCompany"
                        :readonly="isDisabled"
                        :disabled="isDisabled"
                    ></text-input-suggest>
                </validation-provider>
            </div>
        </div>
    </div>
</template>

<script>

import { EVENT_ADD_NEW_PERSON_COMPANY } from '../../services/event-bus/event-types';
import { dadataMixin } from '../../mixins/dadata';

const { eventBus } = window.specialtyApp;

export default {
    name: 'order-person-company',

    mixins: [dadataMixin],

    props: {
        isDisabled: {
            type: Boolean,
            default: false,
        },

        companyProp: {
            type: Object,
        },
    },

    data() {
        return {
            companyName: null,
            companyInn: null,

            newPersonCompany: {},
        };
    },

    watch: {
        newPersonCompany: {
            deep: true,
            handler(data) {
                this.companyName = data.NAME;
                this.companyInn = data.INN;

                eventBus.$emit(EVENT_ADD_NEW_PERSON_COMPANY, data);
            },
        },

        companyName: {
            handler(value) {
                const data = {
                    NAME: value,
                    INN: this.companyInn,
                };

                eventBus.$emit(EVENT_ADD_NEW_PERSON_COMPANY, data);
            },
        },

        companyInn: {
            handler(value) {
                const data = {
                    NAME: this.companyName,
                    INN: value,
                };

                eventBus.$emit(EVENT_ADD_NEW_PERSON_COMPANY, data);
            },
        },

        companyProp: {
            immediate: true,
            deep: true,
            handler(data) {
                if (data) {
                    this.companyName = data.NAME;
                    this.companyInn = data.INN;
                }
            },
        },
    },
};
</script>
